import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Talent() {
  return (
    <section
      className="hire-ios-app-developers-talent hire-dot-net-talent p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="text-center">
              <h2>Learn About Our Current Top .Net Developers</h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="talent-tab position-relative"></div>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              spaceBetween={25}
              slidesPerView={3}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              onSwiper={() => console.log("slide change")}
              onSlideChange={() => console.log("slide change")}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                575: {
                  slidesPerView: 1.5,
                },
                666: {
                  slidesPerView: 1.8,
                },
                768: {
                  slidesPerView: 2,
                },
                1199: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 25,
                },
                1400: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1600: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
                1801: {
                  slidesPerView: 3,
                  spaceBetween: 100,
                },
              }}
              className="carosal_serv "
            >
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Sarah_Thompson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Sarah Thompson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Sarah is a talented .NET Developer who loves working on
                      web applications. She’s been involved in several
                      challenging projects where she built efficient and
                      scalable solutions, especially using ASP.NET Core. Sarah
                      has the aptitude for both backend and frontend work,
                      making her a go-to person for full-stack development.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/James_Peterson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>James Peterson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      James is a versatile .NET Developer with a real passion
                      for combining development with cloud technologies. He’s
                      not just about writing code but he’s deeply involved in
                      how things get built and deployed, especially when it
                      comes to cloud services like AWS. James enjoys working on
                      both the backend and frontend, bringing a comprehensive
                      approach to every project.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Emily_Roberts.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Emily Roberts</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Emily is a creative .NET Developer whose main work
                      involves building mobile and desktop apps. She’s
                      particularly interested in making sure the user experience
                      is smooth, which shows in her thoughtful approach to
                      design and development.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Michael_Johnson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Michael Johnson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Michael is a highly experienced .NET Developer who’s spent
                      years refining his skills in building large, complex
                      applications. He’s known for his ability to lead teams and
                      deliver high-quality, scalable software. Michael enjoys
                      digging into the details to ensure everything runs
                      smoothly, whether he’s working with cloud platforms or
                      fine-tuning application performance.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Sarah_Thompson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Sarah Thompson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Sarah is a talented .NET Developer who loves working on
                      web applications. She’s been involved in several
                      challenging projects where she built efficient and
                      scalable solutions, especially using ASP.NET Core. Sarah
                      has the aptitude for both backend and frontend work,
                      making her a go-to person for full-stack development.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/James_Peterson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>James Peterson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      James is a versatile .NET Developer with a real passion
                      for combining development with cloud technologies. He’s
                      not just about writing code but he’s deeply involved in
                      how things get built and deployed, especially when it
                      comes to cloud services like AWS. James enjoys working on
                      both the backend and frontend, bringing a comprehensive
                      approach to every project.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Emily_Roberts.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Emily Roberts</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Emily is a creative .NET Developer whose main work
                      involves building mobile and desktop apps. She’s
                      particularly interested in making sure the user experience
                      is smooth, which shows in her thoughtful approach to
                      design and development.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/dot_net/talent/Michael_Johnson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={111}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Michael Johnson</h3>
                      <span>.Net Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>ASP.NET</span>
                    <span>SQL</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Michael is a highly experienced .NET Developer who’s spent
                      years refining his skills in building large, complex
                      applications. He’s known for his ability to lead teams and
                      deliver high-quality, scalable software. Michael enjoys
                      digging into the details to ensure everything runs
                      smoothly, whether he’s working with cloud platforms or
                      fine-tuning application performance.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Talent;
